import React, { useEffect, useRef, useState } from "react";
import * as cls from "./learningPlan.module.scss";
import {
  ErrataView,
  Icon,
  WidgetFrame,
} from "../../../personal-studio-components/studio";
import { useSelector } from "react-redux";
import Cell from "../../components/Cell/Cell";
import ModalZetLessons from "../../components/modalZetLessons/ModalZetLessons";
import { StudentService } from "../../components/studentService";
import LegendLingraph from "./LegendLingraph";
import LearningHeader from "./LearningHeader";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";
import { useNavigate } from "react-router-dom";
import LearningPlanMobile from "./LearningPlanMobile";
const TABLET_WIDTH = 768;
const daysInMonth = (month, year) => {
  return new Date(year, month + 1, 0).getDate();
};
// запись в ветке learning plan
const zetColors = [
  "rgb(178, 211, 62)",
  "rgb(70, 101, 51)",
  "rgb(255, 203, 5)",
  "rgb(134, 40, 51)",
  "rgb(121, 60, 86)",
  "rgb(239, 70, 91)",
  "rgb(161, 161, 161)",
  "rgb(20, 69, 121)",
  "rgb(59, 124, 190)",
  "rgb(46, 178, 226)",
  "rgb(85, 140, 235)",
  "rgb(171, 197, 227)",
  "rgb(82, 93, 104)",
  "rgb(134, 142, 149)",
];

function LearningPlan() {
  const [currCellBorder, setCurrCellBorder] = useState({});
  const [data, setData] = useState(null);
  const [currentCourse, setCurrentCourse] = useState(0);
  const [tableHeight, setTableHeight] = useState(0);
  const tableRef = useRef(null);
  const [isScrollTable, setIsScrollTable] = useState(false);
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [errorMessage, setErrorMEssage] = useState(null);
  const [hasLessonsMap, setHasLessonsMap] = useState({});
  const navigate = useNavigate();
  const isMobile = window.innerWidth < TABLET_WIDTH;
  const getLinegraph = async () => {
    const request = {
      method: "post",
      path: "/student/linegraph",
      data: {
        access_token,
        study_contract_id: contractId,
      },
    };
    await StudentService.send(request, (response) => {
      if (response) {
        setErrorMEssage(response);
        if (!response.errors) {
          setCurrentCourse(response.current_course - 1);
          setData(response.course);
        }
      }
    });
  };

  useEffect(() => {
    getLinegraph();
  }, []);

  useEffect(() => {
    if (tableRef.current) {
      if (tableRef?.current.offsetWidth <= 850) {
        setIsScrollTable(true);
      }
      setTableHeight(tableRef.current.offsetHeight);
    }
  }, [data, currentCourse, tableRef?.current?.offsetWidth]);
  useEffect(() => {
    if (errorMessage && errorMessage.error_type === "auth") {
      const errorEvent = new ErrorEvent("error", {
        error: errorMessage,
      });
      window.dispatchEvent(errorEvent);
    }
  }, [errorMessage]);
  useEffect(() => {
    if (!data) return;
    const { columns } = data[currentCourse];

    const uniqueDisciplines = new Map();
    columns.forEach((column) => {
      column.rows.forEach((row) => {
        if (row.ind_mod_discip_id && row.semester_id != null) {
          const key = `${row.ind_mod_discip_id}_${row.semester_id}`;
          if (!uniqueDisciplines.has(key)) {
            uniqueDisciplines.set(key, {
              semester_id: row.semester_id,
              ind_mod_discip_id: row.ind_mod_discip_id,
            });
          }
        }
      });
    });

    let cancelled = false;
    const CONCURRENCY = 8;

    const fetchState = (key, { semester_id, ind_mod_discip_id }) => {
      const request = {
        method: "post",
        path: "/student/linegraph/discip/state",
        data: {
          access_token,
          study_contract_id: contractId,
          semester_id,
          ind_mod_discip_id,
        },
      };
      return StudentService.send(request, (response) => {
        if (!cancelled && response) {
          setHasLessonsMap((prev) => ({
            ...prev,
            [key]: response.has_lessons,
          }));
        }
      }).catch(() => {});
    };

    const run = async () => {
      const entries = Array.from(uniqueDisciplines.entries());
      for (let i = 0; i < entries.length; i += CONCURRENCY) {
        const batch = entries.slice(i, i + CONCURRENCY);
        await Promise.all(batch.map(([key, ids]) => fetchState(key, ids)));
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [data, currentCourse]);
  if (!data && !errorMessage)
    return <WidgetFrame type="blue" icon="loading" title="Учебный план" />;
  if (
    errorMessage &&
    errorMessage.errors &&
    errorMessage.error_type === "info"
  ) {
    return <ErrataViewInfo errata={errorMessage} />;
  }
  if (
    errorMessage &&
    errorMessage.errors &&
    errorMessage.error_type === "other"
  ) {
    return <ErrataView errata={errorMessage} />;
  }
  if (isMobile) {
    return (
      <LearningPlanMobile
        data={data}
        getLinegraph={getLinegraph}
        currentCourse={currentCourse}
        setCurrentCourse={setCurrentCourse}
      />
    );
  }

  const {
    columns,
    start_date,
    end_date,
    days_count,
    columns_count,
    max_rows_count,
    semesters,
  } = data[currentCourse];
  const startDate = new Date(start_date);
  const endDate = new Date(end_date);
  const today = new Date();
  const months = [];
  for (
    let date = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    date <= endDate;
    date.setMonth(date.getMonth() + 1)
  ) {
    months.push(new Date(date));
  }

  const startDay = startDate.getDate();
  const endDay = endDate.getDate();
  const leftPaddingDays = startDay > 1 ? startDay - 1 : 0;
  const endMonthDays = daysInMonth(endDate.getMonth(), endDate.getFullYear());
  const rightPaddingDays = endDay < endMonthDays ? endMonthDays - endDay : 0;

  const width = columns_count;
  const height = max_rows_count;

  let twoDimensionalArray = Array.from({ length: height }, () =>
    Array(width).fill(null),
  );
  const arr = [];

  columns.forEach((column, colIndex) => {
    column.rows.forEach((row, idx) => {
      const rowIndex = row.row_index ? row.row_index - 1 : 0;
      if (rowIndex < height && colIndex < width) {
        twoDimensionalArray[rowIndex][colIndex] = row;
      }
    });
  });
  // заполняем ячейки двухмерного массива каникулами
  columns.forEach((column, colIndex) => {
    column.rows.forEach((row) => {
      if (row.is_holiday) {
        twoDimensionalArray = twoDimensionalArray.map((el) => {
          el = el.map((item, idx) => {
            if (idx === colIndex) {
              item = row;
            }
            return item;
          });
          return el;
        });
      }
      const rowIndex = row.row_index ? row.row_index - 1 : 0;
      if (rowIndex < height && colIndex < width) {
        twoDimensionalArray[rowIndex][colIndex] = row;
      }
    });
  });
  for (let i = 0; i < twoDimensionalArray.length; i++) {
    const element = twoDimensionalArray[i];
    for (let k = 0; k < element.length; k++) {
      if (element[k] === null) continue;
      const item = element[k];
      if (
        !arr.includes(item.ind_mod_discip_id) &&
        item.show_content !== false
      ) {
        arr.push(item.ind_mod_discip_id);
        twoDimensionalArray[i][k].isDiscipNameRender = true;
      }
    }
  }
  if (twoDimensionalArray) {
    setLabelPosition(twoDimensionalArray);
  }
  const dayToPercentage = (days) => (days / days_count) * 100;
  const calculateInnerWidth = (desiredOverallPercentage, columnPercentage) => {
    return (desiredOverallPercentage / columnPercentage) * 100;
  };

  const highlightCell = (cellData) => {
    setCurrCellBorder({
      ind_mod_discip_id: cellData.ind_mod_discip_id,
      semester_id: cellData.semester_id,
    });
  };
  // добавляем нулловые ячейки
  const restoredColumns = columns.map((col, colIndex) => {
    const rows = twoDimensionalArray.map((row, rowIndex) => {
      const cell = row[colIndex];

      if (cell === null) {
        return {
          row_index: rowIndex + 1,
          isEmpty: true,
          original_null: true,
        };
      }
      return cell;
    });

    return {
      ...col,
      rows,
    };
  });

  function setLabelPosition(data) {
    const disciplineMap = {};

    // очистка прошлых флагов
    data.forEach((row) =>
      row.forEach((cell) => {
        if (!cell) return;
        delete cell.renderLabel;
        delete cell.renderPercentPaid;
        delete cell.maxTotalDays;
      }),
    );

    // собираем все ячейки по дисциплине
    data.forEach((row, rowIndex) => {
      // ставим метку в ячейку после каникул
      let isPrevCellHoliday = false;
      row.forEach((cell) => {
        if (!cell) return;
        if (isPrevCellHoliday) {
          cell.isCellAfterHoliday = true;
          isPrevCellHoliday = false;
        }
        if (cell.is_holiday) {
          isPrevCellHoliday = true;
        }
        const { ind_mod_discip_id, semester_id } = cell;
        const key = `${ind_mod_discip_id || "null"}_${semester_id || "null"}`;
        if (!disciplineMap[key]) disciplineMap[key] = [];
        cell._rowIndex = rowIndex;
        disciplineMap[key].push(cell);
      });
    });

    for (const key in disciplineMap) {
      const cells = disciplineMap[key];
      if (!cells.length) continue;

      // группируем в блоки (DFS)
      const visited = new Set();
      const blocks = [];

      function cellId(c) {
        return `${c._rowIndex}_${c.column_index}`;
      }
      function neighbors(c) {
        return cells.filter(
          (o) =>
            o !== c &&
            ((o._rowIndex === c._rowIndex &&
              Math.abs(o.column_index - c.column_index) === 1) ||
              (o.column_index === c.column_index &&
                Math.abs(o._rowIndex - c._rowIndex) === 1)),
        );
      }
      function dfs(start, block) {
        const id = cellId(start);
        if (visited.has(id)) return;
        visited.add(id);
        block.push(start);
        neighbors(start).forEach((n) => dfs(n, block));
      }

      for (const c of cells) {
        if (!visited.has(cellId(c))) {
          const block = [];
          dfs(c, block);
          // сортируем ячейки в блоке в исходном порядке
          block.sort((a, b) => {
            if (a._rowIndex === b._rowIndex) {
              return a.column_index - b.column_index;
            }
            return a._rowIndex - b._rowIndex;
          });
          blocks.push(block);
        }
      }

      // обработка каждого блока

      blocks.forEach((block) => {
        // вставляем каникулы, если есть isCellAfterHoliday
        const holidayIndexes = [];
        let prevIndex = -1;

        block.forEach((el, idx) => {
          if (el.isCellAfterHoliday) {
            if (prevIndex !== -1) {
              holidayIndexes.push(idx); // запоминаем индекс элемента, перед которым вставим
            }
          } else {
            prevIndex = idx;
          }
        });

        // вставляем с конца, чтобы индексы не слетели
        for (let i = holidayIndexes.length - 1; i >= 0; i--) {
          block.splice(holidayIndexes[i], 0, { is_holiday: true });
        }

        const rowsMap = {};
        let holidayHit = false;

        //  считаем дни с учётом каникул
        for (const c of block) {
          if (c.is_holiday) {
            // встретили каникулы => начать новый период
            holidayHit = true;
            continue;
          }

          const row = c.row_index;
          if (row == null) continue;

          // инициализация массива периодов
          if (!rowsMap[row]) rowsMap[row] = [0];

          if (holidayHit) {
            rowsMap[row].push(0);
            holidayHit = false;
          }

          const lastIndex = rowsMap[row].length - 1;
          rowsMap[row][lastIndex] += c.days_count || 0;
        }

        //  вычисляем максимальную сумму дней по строкам
        const rowSums = Object.fromEntries(
          Object.entries(rowsMap).map(([row, periods]) => {
            return [row, Math.max(...periods)];
          }),
        );

        const maxDays = Math.max(...Object.values(rowSums));

        const bestRowIndex = Math.min(
          ...Object.keys(rowSums)
            .filter((r) => rowSums[r] === maxDays)
            .map(Number),
        );

        //  ищем самую левую ячейку в выбранной строке
        const bestRowCells = block.filter((c) => c.row_index === bestRowIndex);

        if (bestRowCells.length > 0) {
          const leftmost = bestRowCells.reduce((min, c) =>
            c.column_index < min.column_index ? c : min,
          );

          leftmost.renderLabel = true;
          leftmost.maxTotalDays = maxDays;
        }

        //  находим самую нижнюю строку
        const minDaysCount = 27; //число изменено с 30 на 27. если количество дней в дисциплине меньше 28 дней, то галки и прочее не будут отображаться
        const daysInRow = Object.entries(rowSums).length > 1 ? minDaysCount : 0;
        const bottomRowIndex = Math.max(
          ...Object.entries(rowSums)
            .filter(([index, days]) => days > daysInRow)
            .map(([idx, el]) => {
              return idx;
            }),
        );

        const bottomCells = block.filter((c) => c.row_index === bottomRowIndex);

        if (bottomCells.length > 0) {
          const leftBottom = bottomCells.reduce((min, c) => {
            return c.days_count > min.days_count ? c : min;
          });

          leftBottom.renderPercentPaid = true;
        }
      });
    }

    // очистим временный _rowIndex
    data.forEach((row) =>
      row.forEach((cell) => {
        if (cell) delete cell._rowIndex;
      }),
    );
  }

  return (
    <ModalZetLessons>
      <WidgetFrame type="blue" icon="survey" title="Учебный план">
        <ul className={cls.courses}>
          {data.map(({ course_name }, idx) => (
            <li
              className={currentCourse === idx ? cls.activeCourse : ""}
              key={idx}
              onClick={() => setCurrentCourse(idx)}
            >
              {course_name}
            </li>
          ))}
        </ul>
        <div className={isScrollTable ? cls.scrollTable : cls.table_container}>
          <div className={cls.table}>
            <div className={cls.table_thead}>
              {months.map((date, idx) => {
                const days = daysInMonth(date.getMonth(), date.getFullYear());
                return (
                  <LearningHeader
                    key={idx}
                    isShowCurrDate={startDate <= today && today <= endDate}
                    days={days}
                    tableHeight={tableHeight}
                    date={date}
                    dayToPercentage={dayToPercentage}
                  />
                );
              })}
            </div>
            <div ref={tableRef} className={cls.table_body}>
              {leftPaddingDays > 0 && (
                <div
                  key="left-padding-body"
                  className={cls.padding_cell}
                  style={{ flexBasis: `${dayToPercentage(leftPaddingDays)}%` }}
                />
              )}

              {restoredColumns.map((column, colIndex) => {
                const flexBasisValue = dayToPercentage(column.days_count);
                const columnPercentage = flexBasisValue; // Процент ширины колонки
                if (column.column_index === "КАНИКУЛЫ") {
                  return (
                    <div
                      key={colIndex}
                      title="КАНИКУЛЫ"
                      className={cls.holiday}
                      style={{
                        flexBasis: `${flexBasisValue}%`,
                      }}
                    ></div>
                  );
                }
                return (
                  <div
                    key={colIndex}
                    className={cls.column}
                    style={{
                      flexBasis: `${flexBasisValue}%`,
                      position: "relative",
                    }}
                  >
                    {twoDimensionalArray.map((row, rowIndex) => {
                      const cellData = row[colIndex];
                      if (column.rows[rowIndex].isEmpty)
                        return <div style={{ height: "5rem" }}></div>;
                      if (cellData) {
                        const percent_paid =
                          semesters[cellData.semester_id].ind_mod_discip_id[
                            cellData.ind_mod_discip_id
                          ].percent_paid;
                        const percent_complete = Math.round(
                          semesters[cellData.semester_id].ind_mod_discip_id[
                            cellData.ind_mod_discip_id
                          ].percent_complete,
                        );
                        const is_elective =
                          semesters[cellData.semester_id].ind_mod_discip_id[
                            cellData.ind_mod_discip_id
                          ].is_elective;

                        const colorIndex =
                          arr.indexOf(cellData.ind_mod_discip_id) %
                          zetColors.length;
                        const desiredOverallPercentage = dayToPercentage(
                          cellData.maxTotalDays,
                        );
                        const zetWidth = calculateInnerWidth(
                          desiredOverallPercentage,
                          columnPercentage,
                        );
                        return (
                          <React.Fragment key={`${rowIndex}-${colIndex}`}>
                            <div style={{ position: "relative" }}>
                              <div
                                className={cls["cell-label"]}
                                style={
                                  cellData.renderLabel && {
                                    fontSize: "0.875rem",
                                    fontWeight: 500,
                                    width: `calc(${zetWidth}% - 20px)`,
                                  }
                                }
                              >
                                {cellData.renderLabel && (
                                  <div>
                                    <div
                                      title={cellData.discip_short_name}
                                      style={{
                                        width: "100%",
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {cellData.discip_short_name}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            <div
                              onMouseEnter={() => highlightCell(cellData)}
                              onMouseLeave={() => setCurrCellBorder({})}
                            >
                              <Cell
                                rowIndex={rowIndex}
                                colIndex={colIndex}
                                cellData={cellData}
                                color={zetColors[colorIndex]}
                                twoDimensionalArray={twoDimensionalArray}
                                width={width}
                                height={height}
                                currCellBorder={currCellBorder}
                                getLinegraph={getLinegraph}
                                highlighted={
                                  currCellBorder.ind_mod_discip_id ===
                                    cellData.ind_mod_discip_id &&
                                  currCellBorder.semester_id ===
                                    cellData.semester_id
                                }
                                is_elective={is_elective}
                                percent_complete={percent_complete}
                                percent_paid={percent_paid}
                                zetWidth={zetWidth}
                                hasLessons={
                                  hasLessonsMap[
                                    `${cellData.ind_mod_discip_id}_${cellData.semester_id}`
                                  ] ?? false
                                }
                              />
                            </div>
                          </React.Fragment>
                        );
                      }
                      return null;
                    })}
                  </div>
                );
              })}
              {rightPaddingDays > 0 && (
                <div
                  key="right-padding-body"
                  className={cls.padding_cell}
                  style={{ flexBasis: `${dayToPercentage(rightPaddingDays)}%` }}
                />
              )}
            </div>
          </div>
        </div>
        <LegendLingraph />
      </WidgetFrame>
    </ModalZetLessons>
  );
}

export default LearningPlan;
